import { Component, OnInit, ViewChild, TemplateRef, OnDestroy } from "@angular/core";
import { NzModalService } from "ng-zorro-antd/modal";
import { NzMessageService } from "ng-zorro-antd/message";
import { InviteService } from "./invite.service";
import { ModalService } from "@root/router/index/modal.service";
import _ from "lodash";
import { DomSanitizer } from "@angular/platform-browser";
import { BeFalseAfter } from "@root/util/decorator";

@Component({
  selector: "host-invite",
  templateUrl: "./invite.component.html",
  styleUrls: ["./invite.component.scss"],
})
export class InviteComponent implements OnInit, OnDestroy {
  @ViewChild("download", { static: true }) downloadTpl: TemplateRef<any>;
  @ViewChild("detail", { static: true }) detailTpl: TemplateRef<any>;
  @ViewChild("withdrawal") withdrawalTpl: TemplateRef<any>;
  @ViewChild("inviteImage") inviteImage: TemplateRef<any>;
  @ViewChild("inviteCode") inviteCode: TemplateRef<any>;

  overview;

  cashbackRate;

  showRules = false;
  inviteDetailList = []; // 邀请明细列表
  withdrawalCodeUrl; // 提现二维码
  withdrawalCodeLoading = false;

  linkText = null;
  clipboard = null;
  firstCopy = true;
  @BeFalseAfter(1000) inviteCodeLoading = false;
  inviteQRCode = null;
  inviteImg = null;
  inviteImgLoading = false;

  constructor(
    private inviteService: InviteService,
    private modalService: NzModalService,
    // private globalModalService: ModalService,
    private messageService: NzMessageService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.fetchInviteOverview();
    this.fetchInviteCashbackRate();
    this.getInviteText();
  }

  fetchInviteOverview() {
    this.inviteService.getInviteOverview().subscribe((res) => {
      console.log("fetch invite overview: ", res);
      this.overview = res && res.data;
    });
  }

  fetchInviteCashbackRate() {
    this.inviteService.getCashbackRate().subscribe((res) => {
      console.log("fetch cashback rate: ", res);
      this.cashbackRate = res && res.data;
    });
  }

  getInviteText() {
    this.inviteService.getInviteLinkText().subscribe((res) => {
      if (res.error_code === 0) {
        this.linkText = _.get(res, "data.text");
      }
    });
  }

  // displayServiceModal() {
  //   this.globalModalService.displayCustomerServiceClient();
  // }

  displayDownloadModal() {
    this.modalService.create({
      nzTitle: null,
      nzContent: this.downloadTpl,
      nzWidth: 290,
      nzFooter: null,
    });
  }

  displayDetailsMdal() {
    this.getInviteDetails();
    this.modalService.create({
      nzTitle: "邀请明细",
      nzContent: this.detailTpl,
      nzWidth: 860,
      nzFooter: null,
    });
  }

  getInviteDetails() {
    this.inviteService
      .getInviteDetail({
        page: 1,
        page_size: 10000,
      })
      .subscribe((res) => {
        if (res.error_code === 0) {
          this.inviteDetailList = _.get(res, "data.list");
        }
      });
  }

  getStatus(status) {
    switch (status) {
      case -1:
        return "未知";
      case 0:
        return "已邀请";
      case 1:
        return "条件不符（邀请账号未付费或被邀请人已享受其他优惠或被邀请人与邀请人重复）";
      case 2:
        return "成功";
      case 3:
        return "超时未支付";
    }
  }

  applyForWithdrawal() {
    this.withdrawalCodeLoading = true;
    this.inviteService.getWithdrawalCode().subscribe((res) => {
      if (res.error_code === 0) {
        this.withdrawalCodeLoading = false;
        this.withdrawalCodeUrl = _.get(res, "data.qrcode");
      }
    });
    this.modalService.create({
      nzTitle: null,
      nzContent: this.withdrawalTpl,
      nzFooter: null,
      nzWidth: 290,
    });
  }

  copy() {
    this.clipboard = new ClipboardJS(".copy");
    this.clipboard.on("success", (e) => {
      const successText = "已复制";
      this.messageService.success(successText);
      this.firstCopy = false;
      // 防止多次点击复制
      setTimeout(() => {
        this.firstCopy = true;
        this.clipboard.destroy();
        this.clipboard = null;
      }, 3000);
    });
  }

  viewInviteImage() {
    this.inviteImgLoading = true;
    setTimeout(() => {
      this.inviteImgLoading = false;
    }, 500);
    this.modalService.create({
      nzTitle: null,
      nzContent: this.inviteImage,
      nzFooter: null,
      nzWidth: 480,
    });
  }

  viewInviteCode() {
    this.inviteService.getInviteCode().subscribe((res) => {
      if (res.error_code === 0) {
        this.inviteQRCode = this.sanitizer.bypassSecurityTrustUrl("data:img/jpg;base64," + _.get(res, "data.qr_code"));
        console.log(this.inviteQRCode);
      }
    });
    this.modalService.create({
      nzTitle: null,
      nzContent: this.inviteCode,
      nzFooter: null,
      nzWidth: 290,
    });
  }

  ngOnDestroy() {
    if (this.clipboard) {
      this.clipboard.destroy();
    }
  }
}
